<template>
  <div>
    <slot v-bind="{ loading: loading, botinfo: botinfo }"></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['pageid'],
  data() {
    return {
      loading: true,
      botinfo: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  async mounted() {
    this.loading = true
    try {
      this.botinfo = await this.getBotInfo()
    } catch (error) {}
    this.loading = false
  },
  methods: {
    async getBotInfo() {
      let response = await this.post('line/modular/bot/info', { pageid: this.pageid })
      if (response.success == true && response.result) {
        return response.result
      } else {
        return null
      }
      // [post] /line/modular/bot/info
      // - body
      // {
      //     "pageid": "630d58d28f77268a2700d543b24bb51b"
      // }
      // - response
      // {
      //     "success": true,
      //     "message": "SUCCESS",
      //     "result": {
      //         "userId": "U8874f08cdd82605bf50c2614154afab0",
      //         "basicId": "@907tbgpq",
      //         "displayName": "test zwiz mo 2",
      //         "pictureUrl": "https://profile.line-scdn.net/0hHkq3fHxkF0RMSgHvUPBoE3APGSk7ZBEMNH5YKjkaGX1nf1MScntRcmxPGnNpKlFFIHwKd24dHXZo",
      //         "chatMode": "chat",
      //         "markAsReadMode": "manual"
      //     }
      // }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/LineProfile.vue